<template>
  <div class="dhmap-wrapper">
    <div class="mapbox" :class="maph">
      <map-selector ref="mapselector" :param="param" mode="h5"></map-selector>
    </div>
    <div class="listbox" v-if="showRecent">
      <p class="ltitle">近期上报的任务</p>
      <div class="emptybox" v-show="!tasklist || tasklist.length ==0">
          <div class="empty"></div>
          <p class="empty-p">暂无数据</p>
      </div>
      <van-cell-group>
        <van-cell v-for="(item) in tasklist" :key="item.id"  center :title="item.title" :label="item.initiatorName+ (item.type=='xf'?' 发起于 ':' 上报于 ') +item.createTime">
          <van-button round plain type="primary" size="small" slot="right-icon" @click="handleSetPosition(item.geometry)">使用此位置</van-button>
        </van-cell>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import WKT from 'ol/format/WKT';
import mapSelector from "@/components/map/MapSelector"
export default {
  name: "tdselector",
  components: {mapSelector},
  props: {},
  data() {
    return {
      param:{},
      showRecent:false,
      tasklist:null,
      maph:'h100'
    }
  },
  mounted(){
    window.getPosition = this.getPosition
    this.param.basemap = 'all'
    if(this.$route.query.zrqlx && this.$route.query.zrqobjid){
      this.param.zrqlx = this.$route.query.zrqlx
      this.param.zrqobjid = this.$route.query.zrqobjid
    }
    if(this.$route.query.lon && this.$route.query.lat){
      this.param.lon = this.$route.query.lon
      this.param.lat = this.$route.query.lat
    }
    this.loadRecentTaskList()
  },
  methods:{
    getPosition(){
      return this.$refs.mapselector.getPosition()
    },
    handleSetPosition(geometry){
      var feature = new WKT().readFeature(geometry, {
          dataProjection: 'EPSG:4326',
          featureProjection: 'EPSG:4326'
      });
      this.$refs.mapselector.setPosition(
        feature.getGeometry().getFlatCoordinates()[0],
        feature.getGeometry().getFlatCoordinates()[1]
      )
    },
    loadRecentTaskList(){
      var _this = this;
      this.$api.Mapapi.getRecentlyTask({
        pageNum:1,
        pageSize:10
      }).then(res => {
        if (res && res.code==1) {
          _this.tasklist = res.data.list
          if(_this.tasklist && _this.tasklist.length > 0){
            _this.showRecent = true
            _this.maph = 'h50'
          }
        } else {
            _this.$toast(res.msg)
        }
      }).catch(() => {_this.$toast('数据请求异常!')})
    }
  },
  computed:{
      
  }
}
</script>

<style scoped>
.dhmap-wrapper{
  width:100%;
  height: 100%;
  overflow: hidden;
}
.mapbox{
  width:100%;
  /* height:50%; */
}
.listbox{
  width: 100%;
  /* height:50%; */
  padding: 0px 10px;
  background: #f8f8f8;
  overflow: auto
}
.h50{
  height:50%;
}
.h100{
  height:100%;
}
.listbox .ltitle{
  color:#666;
  line-height:45px;
  font-size:14px;
  padding-left: 15px;
  border-bottom: 1px solid #e1e1e1
}
/* 暂无数据 */
.emptybox{
    height:calc(100% - 55px);
    padding-top: 50px
}
.empty {
    /* margin-top: 30px; */
    height:100px;
    background-image: url('../../../public/empty.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}
.empty-p {
    margin-top: 15px;
    text-align: center;
    font-size:14px
}

</style>